import block from './block.json';

export const cardNewsThemeAttributes = {
	backgroundColor: '@tokens.variants.default.cardBackgroundColor',
	border: {
		color: '@tokens.variants.default.cardBorderColor',
		width: {
			top: [1, 1],
			right: [3, 3],
			bottom: [1, 1],
			left: [1, 1],
		},
		radius: {
			topLeft: [0, 0],
			topRight: [0, 0],
			bottomRight: [0, 0],
			bottomLeft: [0, 0],
		},
	},
	padding: {
		top: [10, 20],
		right: [10, 20],
		bottom: [10, 20],
		left: [10, 20],
	},
	title: {
		color: '@tokens.variants.default.cardTitleColor',
		typography: '@tokens.typographies.heading-4',
		textAlignment: 'left',
	},
	excerpt: {
		color: '@tokens.variants.default.cardContentColor',
		typography: '@tokens.typographies.paragraph',
		textAlignment: 'left',
	},
	category: {
		color: '@tokens.variants.default.cardContentColor',
		typography: '@tokens.typographies.small-text',
		textAlignment: 'left',
	},
	date: {
		color: '@tokens.variants.default.cardContentColor',
		typography: '@tokens.typographies.small-text',
		textAlignment: 'left',
	},
	read: {
		color: '@tokens.variants.default.cardContentColor',
		typography: '@tokens.typographies.links',
		textAlignment: 'left',
	},
	image: {
		height: [200, 275],
	},
	states: {
		hover: {}, // adds hover state
	},
};

export const CardNewsThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: cardNewsThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
